import {
	trigger, queryInputElementInside, isFunction, isString, isRegexp,
} from "./utils";


function getInputNumbersValue(input) {
	// Return stripped input value — just numbers
	return input.value.replace(/\D/g, '');
}

function onPhonePaste(e) {
	var input = e.target;
	var pasted = e.clipboardData || window.clipboardData;
	if (!pasted) {
		return;
	}

	input.value = pasted;
	formatPhone(input, pasted);
}

function onPhoneFocus(e) {
	var input = e.target;

	if (input.value == "") {
		input.prevalue = "+7 ";
		updateValue(input, "+7 ");
	}
}

function onPhoneBlur(e) {
	var input = e.target;

	if (input.value == "+7 ") {
		input.prevalue = "";
		updateValue(input, "");
		return;
	}

	/**
	 * Проверка на строку вида +7 (987) 731-22-96
	 *  или европейского вида + и до 16 цифр (начинающаяся не с +7)
	 * @type {RegExp}
	 */
	var regex = /^(\+7 \(\d{3}\) \d{3}-\d{2}-\d{2})|(\+[0-689]\d{1,15})$/;
	if (!regex.test(input.value)) {
		input.prevalue = "";
		updateValue(input, "");
	}
}

function onPhoneInput(e) {
	formatPhone(e.target);
}

function formatPhone(input) {
	var inputNumbersValue = getInputNumbersValue(input),
		formattedInputValue = "";

	if (!inputNumbersValue && input.value[0] != "+") {
		updateValue(input, "");
		return;
	}

	/**
	 * Если input сработал после фокуса (input.oldvalue.length == 0),
	 * то удалить префикс "+7 " (input.prevalue) из введенного значения перед форматированием
	 */
	if (
		(undefined === input.oldvalue && undefined === input.prevalue)
		|| (input.oldvalue.length == 0 && input.prevalue.length > 0 && input.prevalue !== input.value)

	) {
		inputNumbersValue = input.value
			.replace(input.prevalue, '')
			.replace(/\D/g, '');
	}

	if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
		/**
		 * Форматирование в строку вида +7 (987) 731-22-96
		 */
		if (inputNumbersValue[0] == "9") inputNumbersValue = "7" + inputNumbersValue;
		var firstSymbols = (inputNumbersValue[0] == "8") ? "+7" : "+7";
		formattedInputValue = firstSymbols + " ";
		if (inputNumbersValue.length > 1) {
			formattedInputValue += "(" + inputNumbersValue.substring(1, 4);
		}
		if (inputNumbersValue.length >= 5) {
			formattedInputValue += ") " + inputNumbersValue.substring(4, 7);
		}
		if (inputNumbersValue.length >= 8) {
			formattedInputValue += "-" + inputNumbersValue.substring(7, 9);
		}
		if (inputNumbersValue.length >= 10) {
			formattedInputValue += "-" + inputNumbersValue.substring(9, 11);
		}
	} else {
		formattedInputValue = "+" + inputNumbersValue.substring(0, 16);
	}

	updateValue(input, formattedInputValue);
}

function onPhoneKeyDown(e) {
	var input = e.target;
	// Clear input after remove last symbol
	var inputNumbersValue = getInputNumbersValue(input);
	if (e.keyCode == 8 && inputNumbersValue.length == 1) {
		updateValue(input, "");
	}
}

/**
 * Convert a mask into a string for comparison
 * @param {String|Array.<String|RegExp>} mask
 */
function maskToString(mask) {
	const maskArray = Array.isArray(mask) ? mask : [mask];
	const filteredMaskArray = maskArray.filter((part) => isString(part) || isRegexp(part));
	return filteredMaskArray.toString();
}

/**
 * Convenience wrapper for `trigger(el, "input")`, which raises
 * an event for Vue to detect a value change.
 *
 * @param {HTMLInputElement} el
 */
function triggerInputUpdate(el) {
	trigger(el, "input");
}

/**
 * Event handler
 * @param {HTMLInputElement} el
 * @param newValue
 */
function updateValue(el, newValue) {
	if (newValue == el.value) {
		return;
	}

	el.oldvalue = el.value;
	el.value = newValue;
	triggerInputUpdate(el);
}

/**
 * Create the Vue directive
 * @param {Object}                  directiveOptions
 * @param {Object.<string, RegExp>} directiveOptions.placeholders
 * @return {Object} The Vue directive
 */
export function createDirective(directiveOptions = {}) {
	/**
	 * Vue directive definition
	 */
	return {
		bind(el, binding) {
			el = queryInputElementInside(el);

			el.addEventListener("keydown", onPhoneKeyDown);
			el.addEventListener("input", onPhoneInput, false);
			el.addEventListener("paste", onPhonePaste, false);
			el.addEventListener("focus", onPhoneFocus, false);
			el.addEventListener("blur", onPhoneBlur, false);

			formatPhone(el);
		},
		/**
		 * Called only once, when the directive is first bound to the element.
		 * This is where you can do one-time setup work.
		 *
		 * @param {(HTMLInputElement|HTMLElement)} el
		 * @param {?String}                        value
		 */
		inserted(el, {value}) {

		},

		/**
		 * Called after the containing component has updated,
		 * but possibly before its children have updated.
		 * The directive’s value may or may not have changed,
		 * but you can skip unnecessary updates by comparing the
		 * binding’s current and old values.
		 *
		 * @param {(HTMLInputElement|HTMLElement)} el
		 * @param {?String}                        value
		 * @param {?String}                        oldValue
		 */
		componentUpdated(el, {value, oldValue}) {
			el = queryInputElementInside(el);
		},

		unbind(el) {
			el.removeEventListener("keydown", onPhoneKeyDown);
			el.removeEventListener("input", onPhoneInput, false);
			el.removeEventListener("paste", onPhonePaste, false);
			el.removeEventListener("focus", onPhoneFocus, false);
			el.removeEventListener("blur", onPhoneBlur, false);
		},
	}
}

/**
 * Default directive definition
 */
export default createDirective();
